import React from "react";
import { ReactComponent as ImagePlaceHolder } from "../../../../public/preview_image_placeholder.svg";
import { Modal, Spinner } from "react-bootstrap";
import { connect } from "react-redux";
import ImagePicker from "../../../shared/ImagePicker";
import { log_error } from "../../../../api";
import { Redirect } from "react-router-dom";
import { createPlaylist, addMediumToPlaylist } from "../../../../api/playlists";
import MusicGenres from "../MusicGenres";

class NewPlaylistModal extends React.Component {
  state = {
    show: false,
    medium: null,
    error: null,
    loading: false,
    name: "",
    tags: [],
    playlist: null,
  };
  handleClick = e =>
    this.hocWrapper.current.contains(e.target) && this.handleShow();
  componentDidMount = () =>
    document.body.addEventListener("click", this.handleClick);
  componentWillUnmount = () =>
    document.body.removeEventListener("click", this.handleClick);
  handleClose = () => this.setState({ show: false });
  handleShow = () => this.setState({ show: true });
  hocWrapper = React.createRef();

  addTrack = async id => {
    try {
      await addMediumToPlaylist(id, {
        playlists_medium: { medium_id: this.props.medium.id },
      });
    } catch (error) {
      console.log("error =>", error);
    }
  };

  onCreatePlaylist = async () => {
    try {
      this.setState({ loading: true, error: null });
      let {
        data: { playlist },
      } = await createPlaylist({
        preview_image_id: this.state.medium && this.state.medium.id,
        title: this.state.name,
        tags: this.state.tags,
      });
      if (this.props.medium) this.addTrack(playlist.id);
      this.setState({ playlist });
      this.handleClose();
    } catch (error) {
      console.log(error);
      this.setState({ error: log_error(error) });
    } finally {
      this.setState({ loading: false });
    }
  };

  updateGenres = tags => {
    this.setState({ tags });
  };

  render() {
    return (
      <>
        <div
          ref={this.hocWrapper}
          className={"hor_click " + this.props.className}
        >
          {this.props.children}
        </div>
        {this.state.playlist && (
          <Redirect
            to={`/${this.props.current_user.slug}/playlists/${this.state.playlist.id}`}
          />
        )}
        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Body className="text-center p-5">
            <ImagePicker onSubmit={medium => this.setState({ medium })}>
              {this.state.medium ? (
                <img
                  className="w-50 mb-4"
                  alt={this.state.medium.id}
                  src={this.state.medium.url}
                />
              ) : (
                <ImagePlaceHolder className="w-50 h-50 mb-4" />
              )}
            </ImagePicker>
            <input
              onChange={({ target: { value } }) =>
                this.setState({ name: value })
              }
              placeholder="Playlist Name"
              className="form-control text-center mb-5"
            />
            <MusicGenres defaultChecked={[]} onChange={this.updateGenres} />
            <div className="d-flex justify-content-between">
              <button
                disabled={this.state.loading}
                onClick={this.handleClose}
                className="btn btn-lg btn-outline-primary"
              >
                Cancel
              </button>
              <button
                onClick={this.onCreatePlaylist}
                className="btn btn-lg btn-primary"
              >
                {this.state.loading ? <Spinner animation="border" /> : "Save"}
              </button>
            </div>
            {this.state.error &&
              this.state.error.map(e => (
                <div className="alert alert-danger mt-2 mb-n4">{e.message}</div>
              ))}
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
export default connect(a => a)(NewPlaylistModal);
